
import {tap,  finalize } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http'

import { Observable } from 'rxjs'
import { CustomErrorHandler } from './custom_error_handler'
import { Router } from '@angular/router'

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    public errorHandler: CustomErrorHandler
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token')
    request = request.clone({
        setHeaders: { 
            Authorization: `Bearer ${token}`
        }
    })
    /*
    const clonedRequest = request.clone({ setHeaders: { 
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' } })
        */
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {}, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        this.errorHandler.handleError(err)
        if (err.status === 401 && !window.location.pathname.includes('login')) {
          localStorage.clear()
          this.router.navigate(['login']).then(() => {
            window.location.reload();
          })
        }
      }
    })).pipe(
      finalize(() => {    
        
      })
    )
  }
}
